import { render, staticRenderFns } from "./UploadFiles3.vue?vue&type=template&id=60b29932&scoped=true"
import script from "./UploadFiles3.vue?vue&type=script&lang=js"
export * from "./UploadFiles3.vue?vue&type=script&lang=js"
import style1 from "./UploadFiles3.vue?vue&type=style&index=1&id=60b29932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b29932",
  null
  
)

export default component.exports